module.exports = __webpack_public_path__ + "static/media/08.c44eac2b.mp3";